export const DEFAULT_APP = '/public/profile/artistProfile'
export const DEFAULT_URL = '/account'
export const PROFILE = 'profile'
export const ARTWORKS = 'artworks'
